var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModelWhyPartners3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3501_10156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9583 11.6667C24.975 11.39 25 11.115 25 10.8333C25 10.5517 24.9733 10.2767 24.9583 10H30.8333C31.6117 10 32.3317 10.2283 32.9567 10.6C32.295 10.8683 31.6983 11.255 31.145 11.6967C31.0417 11.6833 30.9417 11.665 30.835 11.665H24.96L24.9583 11.6667ZM33.3333 38.3333H6.66667V24.375C6.09333 24.1983 5.54 23.9783 5 23.7333V40H35V28.94L33.3333 30.6067V38.3333ZM10.8333 21.6667C4.86 21.6667 0 16.8067 0 10.8333C0 4.86 4.86 0 10.8333 0C16.8067 0 21.6667 4.86 21.6667 10.8333C21.6667 16.8067 16.8067 21.6667 10.8333 21.6667ZM10.8333 20C15.8883 20 20 15.8867 20 10.8333C20 5.78 15.8883 1.66667 10.8333 1.66667C5.77833 1.66667 1.66667 5.78 1.66667 10.8333C1.66667 15.8867 5.77833 20 10.8333 20ZM16.9017 8.77L15.7333 7.58167L9.96667 13.2517C9.87667 13.3467 9.66833 13.3433 9.565 13.2417L6.47167 10.2417L5.31167 11.44L8.39667 14.43C8.765 14.7983 9.25333 15 9.77167 15C10.29 15 10.7783 14.7983 11.1417 14.435L16.9033 8.77H16.9017ZM38.7783 20.4467L25.8917 33.3333H19.9983V27.4417L32.885 14.555C34.4567 12.98 37.205 12.98 38.7767 14.555C40.4017 16.18 40.4033 18.8233 38.7783 20.4467ZM37.6 15.7333C36.6567 14.79 35.0083 14.79 34.065 15.7333L21.6667 28.1317V31.6667H25.2033L37.6017 19.2683C38.5767 18.2933 38.5767 16.7083 37.6017 15.7333H37.6Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3501_10156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelWhyPartners3);
export default __webpack_public_path__ + "static/media/model-why-partners-3.46ca06c673ff3a8c0a810bddb2a71de0.svg";
export { ForwardRef as ReactComponent };